import { useCallback, useState } from "react"
import { useEffect } from "react"
import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import UserContext from "../../Context/UserContext"
import { getGroupsDocWhereExhibitorAndEvent } from "../../Requests/firebaseFirestore"

export default function GroupsAsStaff(){
  const {user} = useContext(UserContext)
  const [groups, setGroups] = useState([])
  const navigate = useNavigate()

  const getInfo = useCallback(async()=>{
    const grps = await getGroupsDocWhereExhibitorAndEvent(user.exhibitor.id, user.event.id)
    setGroups([...grps])
    console.log(grps)
  },[user])

  useEffect(()=>{
    getInfo()
  },[])

  return <>
    <h1 className="text-stone-600 font-semibold text-xl py-2">Grupos de {user.event.name}</h1>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {groups.map((group, index)=>{return(
        <button className="group-btn" onClick={()=>{navigate(`/staff/group/${group.id}`)}} key={index}>{group.name}</button>
      )})}
    </div>
  </>
}